module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page",
    attrs: {
      "id": "app"
    }
  }, [_c('router-view', {
    staticClass: "content"
  }), _vm._v(" "), _c('el-backtop'), _vm._v(" "), (
    _vm.curRoutePath == '/user/proxyRegister/register' ||
    _vm.curRoutePath == '/user/proxyRegister/orderConfirm' ||
    _vm.curRoutePath == '/user/proxyRegister/paySuccess' ||
    (_vm.userInfo && _vm.userInfo.proxyCustomerloginFlag == 1)
  ) ? _c('div', {
    staticClass: "float-tip"
  }, [_c('el-row', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "type": "flex",
      "align": "middle"
    }
  }, [_c('el-col', {
    staticClass: "p-l-15",
    attrs: {
      "span": 4
    }
  }, [_c('img', {
    staticStyle: {
      "width": "30px",
      "height": "30px",
      "margin-top": "3px"
    },
    attrs: {
      "src": "/static/img/mini-logo.png"
    }
  })]), _vm._v(" "), _c('el-col', {
    staticClass: "p-l-15",
    attrs: {
      "span": 20,
      "align": "middle"
    }
  }, [(_vm.curRoutePath == '/user/proxyRegister/register') ? _c('p', {
    staticClass: "font-size-16"
  }, [_c('em', [_vm._v(_vm._s(_vm.$t(_vm.actionMap[_vm.curRoutePath])))])]) : _vm._e(), _vm._v(" "), (_vm.curRoutePath == '/user/proxyRegister/shopping') ? _c('p', {
    staticClass: "font-size-16"
  }, [_c('em', [_vm._v(_vm._s(_vm.$t(_vm.actionMap[_vm.curRoutePath])))])]) : _vm._e(), _vm._v(" "), (_vm.curRoutePath == '/user/proxyRegister/orderConfirm') ? _c('p', {
    staticClass: "font-size-16"
  }, [_c('em', [_vm._v(_vm._s(_vm.$t(_vm.actionMap[_vm.curRoutePath])))])]) : _vm._e(), _vm._v(" "), (_vm.curRoutePath == '/user/proxyRegister/shopping' || _vm.curRoutePath == '/user/proxyRegister/orderConfirm' || _vm.curRoutePath == '/user/proxyRegister/paySuccess') ? _c('p', {
    staticClass: "font-size-14"
  }, [_vm._v("\n          Id:" + _vm._s(_vm.userInfo.proxyUser.userId) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.curRoutePath == '/registerShopping') ? _c('p', {
    staticClass: "font-size-16"
  }, [_c('em', [_vm._v(_vm._s(_vm.$t(_vm.actionMap[_vm.curRoutePath])))])]) : _vm._e(), _vm._v(" "), (_vm.curRoutePath == '/registerShopping') ? _c('p', {
    staticClass: "font-size-16"
  }, [_vm._v("Id:" + _vm._s(_vm.userInfo.userId))]) : _vm._e(), _vm._v(" "), ((_vm.userInfo && _vm.userInfo.proxyCustomerloginFlag == 1)) ? _c('p', {
    staticClass: "font-size-16"
  }, [_vm._v(_vm._s(_vm.$t(8003034)))]) : _vm._e()])], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-81176f6e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 324
// module chunks = 75